import React  from "react";
import { Container } from "react-bootstrap";
import { useSelector } from "react-redux";
import Slider from "react-slick";
import "../../../Assets/Scss/Recommended.scss";
import { getImageUrl } from "../../../Utils/index";
import PlaceholderImage from "../../../Assets/Images/PlaceholderImage.png";

function Recommended() {

  const { domainData } = useSelector((state) => state.Website);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };



  return (
    <div className="carousel">
      <Container className=" pb-0 pt-0 mb-0 mt-0">
        <h5 className="Recommended pb-0 pt-0 mb-0 mt-0">Recommended</h5>
      </Container>

      <Slider {...settings}>
        {domainData &&
          domainData.images.map((ele) => (
            <div key={ele} className="banner-carousel--item">
              <img
                src={getImageUrl(ele, PlaceholderImage)}
                height="400px"
                width="100%"
                alt="banner"
              />
            </div>
          ))}
      </Slider>
    </div>
  );
}

export default Recommended;
